<template>
    <div>
        <Card>
            <template #title>
                Perfil
            </template>
            <template #content>
                <Toolbar class="mb-2 bg-gray-100">
                    <template #end>
                        <div class="flex items-center gap-1">
                            <Button icon="pi pi-plus" label="Incluir" severity="info" size="small"
                                @click="openForm({})" />
                            <Button icon="pi pi-search" label="Buscar" severity="success" size="small"
                                @click="toggleBusca" />
                            <Button icon="pi pi-refresh" label="Atualizar" severity="warn" size="small"
                                @click="loadData" />
                        </div>
                    </template>
                </Toolbar>

                <DataTable :value="lista" :loading="isLoading" size="small" stripedRows showGridlines scrollable
                    scrollHeight="calc(100vh - 300px)" :sortField="params.sort.field" :sortOrder="params.sort.order"
                    @sort="onTableSort">

                    <Column style="width: 100px" field="id" header="#" sortable></Column>
                    <Column field="descricao" header="Descrição" sortable>
                        <template #body="{ data }">
                            <span class="flex align-items-center gap-2">
                                {{ data.descricao }}
                                <Tag v-if="data.administrador" value="Administrador" severity="info" />
                            </span>
                        </template>
                    </Column>
                    <Column style="width: 120px" bodyClass="flex justify-content-end gap-1">
                        <template #body="{ data }">
                            <Button icon="pi pi-list" title="Permissões" severity="secondary" size="small"
                                @click="openFormPermissoes(data)" />
                            <Button icon="pi pi-pen-to-square" title="Atualizar" class="p-button-rounded p-button-text p-button-info p-0 w-2rem h-2rem"
                                @click="openForm(data)" />
                            <Button icon="pi pi-trash" class="p-button-rounded p-button-text p-button-danger p-0 w-2rem h-2rem"
                                :disabled="!!data.administrador && !permissoes.USUARIO_REMOVER_ADMINISTRADOR"
                                :title="data.administrador && !permissoes.USUARIO_REMOVER_ADMINISTRADOR ? 'Você não tem permissão para remover administrador.' : 'Remover'"
                                @click="remove(data)" />
                        </template>
                    </Column>

                    <template #empty>
                        <div class="text-center text-gray-600">
                            Nenhum registro encontrado
                        </div>
                    </template>
                </DataTable>

                <div class="flex justify-content-between flex-wrap">
                    <div class="flex align-items-center justify-content-center">
                        <div class="flex justify-end mt-2 text-sm text-gray-600">
                            <span>{{ pagination.total }} registros</span>
                        </div>

                    </div>
                    <div class="flex align-items-center justify-content-center">
                        <Paginator :first="pagination.first" :rows="pagination.perPage" :totalRecords="pagination.total"
                            @page="onPage">
                        </Paginator>
                    </div>
                    <div class="flex align-items-center justify-content-center">
                    </div>
                </div>

            </template>
        </Card>
        <PerfilForm :visible="visibleForm" :data="item" :podeAdministrar="!!permissoes.ADMINISTRADOR" :podeRemoverAdministrador="!!permissoes.USUARIO_REMOVER_ADMINISTRADOR"
            @close="closeForm" @save="loadData" />
        <PermissoesForm :visible="visibleFormPermissoes" :perfil="item" :podeAdministrar="!!permissoes.ADMINISTRADOR" :podeRemoverAdministrador="!!permissoes.USUARIO_REMOVER_ADMINISTRADOR" @close="closeFormPermissoes" @save="loadData">
        </PermissoesForm>
        <Popover ref="busca" :closeOnEscape="false" :dismissable="false" class="w-3">
            <div class="w-full">
                <form @submit.prevent="onSubmitBusca">
                    <div class="w-full">
                        <div class="field mt-4">
                            <FloatLabel>
                                <InputText id="descricao" v-model="params.filter.descricao" class="w-full" />
                                <label for="descricao">Descricao</label>
                            </FloatLabel>
                        </div>
                    </div>

                    <div class="flex justify-content-end gap-1">
                        <Button type="submit" label="Buscar" severity="success" icon="pi pi-search"
                            class="flex align-items-center justify-content-center" />
                        <Button icon="pi pi-eraser" label="Limpar" severity="warn" size="small"
                            class="flex align-items-center justify-content-center" @click="onClearBusca" />
                        <Button icon="pi pi-times" label="Fechar" severity="danger" size="small"
                            class="flex align-items-center justify-content-center" @click="toggleBusca" />
                    </div>
                </form>
            </div>

        </Popover>
    </div>
</template>
<script>
import Card from 'primevue/card';

/* Table */
import Toolbar from 'primevue/toolbar';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Paginator from 'primevue/paginator';
import Column from 'primevue/column';
import Tag from 'primevue/tag';

import Popover from 'primevue/popover';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';

import Perfil from '@/service/perfil.js';
import Auth from '@/service/auth.js';
import PerfilForm from '@/page/perfil/Form.vue';
import PermissoesForm from '@/page/perfil/FormPermissoes.vue';

import Filter from '@/utils/Filter.js';

export default {
    components: {
        Card,
        Toolbar,
        Button,
        DataTable,
        Paginator,
        Column,
        Tag,

        /* Busca */
        Popover,
        FloatLabel,
        InputText,

        /* Form */
        PerfilForm,
        PermissoesForm,
    },
    data() {
        return {
            lista: [],
            isLoading: false,
            item: {},
            visibleForm: false,
            visibleFormPermissoes: false,
            permissoes: {},


            params: {
                filter: {},
                sort: {
                    field: 'id',
                    order: 1
                }
            },
            pagination: {
                page: 0,
                perPage: 0,
                total: 0,
            },
        }
    },
    beforeMount() {
        this.pagination.page = parseInt(this.$route.query.page || 0);
        document.addEventListener('onPermissios', this.onPermissios);
    },
    mounted() {
        this.loadData();
        // O router só dispara `onPermissios` no primeiro acesso a /app; na navegação
        // pelo menu o evento já passou, então busca direto.
        Auth.permissoes()
            .then(response => this.permissoes = response.data ?? {})
            .catch(() => {});
    },
    beforeUnmount() {
        document.removeEventListener('onPermissios', this.onPermissios);
    },
    methods: {
        onPermissios(event) {
            this.permissoes = event.permissoes ?? {};
        },
        openForm(item) {
            this.item = { ...item };
            this.visibleForm = true;
        },
        openFormPermissoes(item) {
            this.item = { ...item };
            this.visibleFormPermissoes = true;
        },
        closeForm(event) {
            this.item = {};
            this.visibleForm = false;

            if (event.novo) {
                this.openFormPermissoes(event.perfil);
            }

        },
        closeFormPermissoes(event) {
            this.item = {};
            this.visibleFormPermissoes = false;
        },
        remove(data) {
            this.$confirm.require({
                message: 'Deseja realmente remover o item?',
                header: 'Remover',
                acceptLabel: 'Remover',
                icon: 'pi pi-trash',
                acceptClass: 'bg-red-500 text-white border-red-500',
                rejectLabel: 'Cancelar',
                rejectClass: 'bg-red-400 text-white',
                accept: () => {
                    this.isLoading = true;
                    Perfil.delete(data.id)
                        .then(response => {
                            this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'O item foi removido com sucesso.', life: 3000 });
                            this.loadData();
                        })
                        .catch(error => {
                            if (error.response) {
                                if (error.response.data.msg) {
                                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                                    return;
                                }
                            }
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                },
            });
        },
        loadDataParams() {
            let params = [];

            // Pagination
            params.push(`page=${1 + this.pagination.page}`);

            // Filter
            params = Filter.formToQuery(this.params.filter, params);

            // Order
            params.push(`order[${this.params.sort.field}]=` + (this.params.sort.order > 0 ? 'asc' : 'desc'));
            return params;
        },
        loadData() {
            let params = this.loadDataParams();

            this.isLoading = true;
            Perfil.list(params.join("&"))
                .then(response => {
                    this.lista = response.data.data;
                    this.pagination.perPage = response.data.per_page;
                    this.pagination.total = response.data.total;
                    this.pagination.first = response.data.per_page * this.pagination.page;
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        // Filter
        toggleBusca(event) {
            this.$refs.busca.toggle(event);
        },
        onClearBusca(event) {
            this.toggleBusca(event);
            this.params.filter = {};
            this.onPage();
        },
        onSubmitBusca(event) {
            this.toggleBusca(event);
            this.onPage();
        },

        // Paginate
        onPage(event) {
            const page = event ? event.page : 0;
            this.pagination.page = page;
            this.$router.replace({ name: this.$route.name, query: { page: page } });
            this.loadData();
        },

        // Sort
        onTableSort(event) {
            this.params.sort = {
                field: event.sortField,
                order: event.sortOrder,
            };
            this.loadData();
        }
    }
}
</script>
